const GLOBALS = {
  HEADLESS_COMPONENTS: {},
  FROZEN_STATE: false,
  VERSION: '0.4.2',
  // TODO: Collect active components
  ACTIVE_COMPONENTS: {},
  CUSTOM_ATTRIBUTES: {},
  CUSTOM_TAGS: {},
};

export default GLOBALS;
